// User-facing Template Library categories. Display/filter metadata only: resolved from library_key so the raw pack
// `category`, schema_json, rules_json, checksums and origin_ref stay untouched (see docs/audit/09-day1-...md Part 1).
export const LIBRARY_CATEGORIES = [
  'Organisation & Governance',
  'Participant Records',
  'Participant Risk & Assessment',
  'Staff & Workforce',
  'Complaints & Feedback',
  'Incidents & Safeguarding',
  'Work Health & Safety',
  'Service Delivery',
  'Money & Property',
  'Emergency & Disaster',
];

export const OTHER_CATEGORY = 'Other';

const BY_KEY = {
  internal_audit_checklist: 'Organisation & Governance',
  nominee_record: 'Participant Records',
  participant_satisfaction_survey: 'Participant Records',
  home_risk_assessment: 'Participant Risk & Assessment',
  participant_disaster_emergency_risk_assessment: 'Participant Risk & Assessment',
  behaviour_support_risk_assessment: 'Participant Risk & Assessment',
  worker_performance_assessment: 'Staff & Workforce',
  worker_induction_competency_checklist: 'Staff & Workforce',
  complaint_resolution_followup_record: 'Complaints & Feedback',
  post_incident_review_corrective_action: 'Incidents & Safeguarding',
  house_office_safety_inspection: 'Work Health & Safety',
  participant_transition_plan: 'Service Delivery',
  client_money_property_consent: 'Money & Property',
  client_money_reconciliation_record: 'Money & Property',
  emergency_drill_report: 'Emergency & Disaster',
  site_emergency_disaster_management_plan: 'Emergency & Disaster',
};

export const displayCategory = (libraryKey) => BY_KEY[libraryKey] || OTHER_CATEGORY;
export const categoryFilterOptions = () => [...LIBRARY_CATEGORIES, OTHER_CATEGORY];
